<div class="card-body">
  <div [hidden]="aba !== 8">
    <div class="row mb-1">
      <div class="col-md-12" style="font-weight: bold;">
        Papéis de Trabalho
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-2">
        <button class="btn btn-info btn-sm mr" (click)="imprimir()">
          <i class="far fas fa-print fa-sm"></i> Imprimir
        </button>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-12">
        <div class="example-list" cdkDropList (cdkDropListDropped)="drop($event)">
          <div class="example-box" cdkDrag *ngFor="let item of model">
            <div class="row mb-2">
              <div class="col-md-3">
                <button *ngIf="exibeRemoverPapel(item)" type="button" class="btn btn-danger btn-sm mr-1"
                  (click)="removePapel(item)">
                  <i class="fas fa-trash"></i>
                </button>
                <b>{{ getSigla(item) }}</b> -
                {{ item.nomePapel }}
                {{ getSituacao(item) }}
              </div>
              <div class="col-md-3">
                <select
                  [disabled]="visualizar"
                  id="selectTipo"
                  class="form-control form-control-sm"
                  [(ngModel)]="item.idTipoAceitavel"
                  (change)="mudaTipoAceitavel(item.idTipoAceitavel)">
                  <option value="1">Coletado</option>
                  <option value="2">Não-Coletado</option>
                  <option value="3">Produzido pelo Auditor</option>
                </select>
              </div>
              <div class="col-md-6">
                <div *ngIf="item.idTipoAceitavel != 2">
                  <div class="row mb-1">
                    <div class="col-md-12">
                      <div class="input-group" *ngIf="visualizar == false">
                        <input
                          type="file"
                          class="form-control-file"
                          id='{{ "file_" + item.controle }}'
                          name='{{ "file_" + item.controle }}'
                          multiple="multiple"
                          (change)="uploadAmostra($event, item)"
                          class="inputfile"/>
                        <label for='{{ "file_" + item.controle }}' class="button-style btn btn-warning btn-sm">
                          <i class="fa fa-upload" aria-hidden="true"></i>&nbsp;Selecionar arquivos</label>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-1" *ngFor="let arquivo of item.arquivos">
                    <div class="col-md-12">
                      <div class="input-group div-input-file" style="padding: 3px;">
                        <table style="width: 100%;border:none;" [cellPadding]="0" [cellSpacing]="0">
                          <tr>
                            <td>
                              {{ arquivo.nome }}
                            </td>
                            <td style="width: 5%;">
                              <button type="button" class="btn btn-primary btn-sm mr-1" (click)="download(arquivo)">
                                <i class="fas fa-download"></i>
                              </button>
                            </td>
                            <td style="width: 5%;">
                              <button *ngIf="visualizar == false" type="button" class="btn btn-danger btn-sm mr-1" (click)="removeFile(item, arquivo)">
                                <i class="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="exibeLink(item)">
                  <div class="row mb-1">
                    <input
                      [disabled]="visualizar"
                      [(ngModel)]="item.link"
                      type="text"
                      maxlength="500"
                      class="form-control"
                      [class.is-invalid]="item.link && item.link.trim() !== '' && !isValidUrl(item.link)"
                      placeholder="Link"/>
                    <div class="invalid-feedback" *ngIf="item.link && item.link.trim() !== '' && !isValidUrl(item.link)">
                      O link informado não é válido. Verifique o formato e tente novamente.
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12" *ngIf="exibeJustificativa(item)">
                <input [disabled]="visualizar" type="text" [(ngModel)]="item.justificativa" maxlength="1000" class="form-control" placeholder="Justificativa"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card-footer" *ngIf="exibeSalvar()">
  <div class="row">
    <div class="col-md-2">
      <div class="btn-group" [hidden]="visualizar">
        <button class="btn btn-primary btn-sm mr" (click)="salvar(false)">
            <i class="far fa-save"></i> Salvar
        </button>
        <button type="button" class="btn btn-primary btn-sm mr dropdown-toggle dropdown-icon" data-toggle="dropdown" aria-expanded="false"></button>
        <div class="dropdown-menu" role="menu">
        <a class="dropdown-item" (click)="salvar(false)">Salvar</a>
        <a class="dropdown-item" (click)="salvar(true)">Salvar e fechar</a>
        </div>
      </div>
    </div>
    <div class="col-md-8">

    </div>
    <div class="col-md-2" style="text-align: end;">
      <div class="btn-group" [hidden]="visualizar">
        <button class="btn btn-success btn-sm mr" (click)="novoPapel()">
            <i class="fas fa-plus"></i> Adicionar
        </button>
      </div>
    </div>
  </div>
</div>
